// Promos por revalidar: el cobro y el cierre no avanzan mientras una línea viva traiga la marca.
import type { WizardSession } from './types';

export const PROMOTION_NOT_REVALIDATED = 'PROMOTION_NOT_REVALIDATED';

export const PROMOTION_REVALIDATION_MESSAGE = 'Hay una promoción o código por revalidar';

/** Toast del 409 del silo en folio, cobro o cierre. */
export const PROMOTION_NOT_REVALIDATED_TOAST = `${PROMOTION_REVALIDATION_MESSAGE}. Regresa a Accesorios.`;

/** Ids de las líneas vivas que Promociones todavía no revalida; misma regla que el silo. */
export function pendingRevalidationLineIds(session: WizardSession | undefined): string[] {
    return (session?.reservedLines ?? [])
        .filter((l) => l.status !== 'RELEASING' && l.promotionRevalidationPending === true)
        .map((l) => l.lineId);
}
